import { GeneralService } from './../../../services/general.service';
import { FormGroup } from '@angular/forms';

export class FormRs009Build {

    public areaSelect: string = localStorage.getItem('area-select') || null;

    public async buildForm(form: FormGroup, arrForm: Array<FormGroup>): Promise<FormGroup> {
        form = await this.buildFormI(form, arrForm[0]);
        form = await this.buildFormII(form, arrForm[1]);
        form = await this.buildFormIII(form, arrForm[2]);
        form = await this.buildFormVI(form, arrForm[3]);
        form = await this.buildFormV(form, arrForm[4]);
        return form;
    }

    private async buildFormI(form: FormGroup, formCard: FormGroup): Promise<FormGroup> {

        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('cerar_basica').setValue(formCard.get('cerar_basica')?.value);
            form.get('lote_rw').setValue(formCard.get('lote_rw')?.value);
            form.get('cooperante').setValue(formCard.get('cooperante')?.value);
            form.get('gleba').setValue(formCard.get('gleba')?.value);
            form.get('contrato_juridico').setValue(formCard.get('contrato_juridico')?.value);
            form.get('geracao').setValue(formCard.get('geracao')?.value);
            form.get('site_origem').setValue(formCard.get('site_origem')?.value);
            form.get('site_recebimento').setValue(formCard.get('site_recebimento')?.value)
            form.get('safra').setValue(formCard.get('safra')?.value);;
            form.get('safra_basica').setValue(formCard.get('safra_basica')?.value);
            form.get('numero_campo').setValue(formCard.get('numero_campo')?.value);
            form.get('hibrido_rnc').setValue(formCard.get('hibrido_rnc')?.value);
            form.get('especie').setValue(formCard.get('especie')?.value);
            form.get('tipo_colheita').setValue(formCard.get('tipo_colheita')?.value);
            form.get('amostra_seca_molhada').setValue(formCard.get('amostra_seca_molhada')?.value);
            form.get('peso_total_rw').setValue(formCard.get('peso_total_rw')?.value);
            form.get('umidade').setValue(formCard.get('umidade')?.value);
        }
        else {
            form.get('cerar').setValue(formCard.get('Cerar')?.value);
            form.get('lote_rw').setValue(formCard.get('Lote_rw')?.value);
            form.get('site_origem').setValue(formCard.get('Site_Origem')?.value);
            form.get('site_recebimento').setValue(formCard.get('Site_Recebimento')?.value);
            form.get('cooperante').setValue(formCard.get('Cooperante')?.value);
            form.get('gleba').setValue(formCard.get('Gleba')?.value);
            form.get('contrato_juridico').setValue(formCard.get('Contrato_Juridico')?.value);
            form.get('produto').setValue(formCard.get('Produto')?.value);
            form.get('peso_amostra').setValue(formCard.get('Peso_Amostra')?.value);
            form.get('peso_liquido').setValue(formCard.get('Peso_Liquido')?.value);
            form.get('palha').setValue(formCard.get('Palha')?.value);
            form.get('outras_sementes').setValue(formCard.get('Outras_Sementes')?.value);
            form.get('impurezas').setValue(formCard.get('Impurezas')?.value);
            form.get('safra').setValue(formCard.get('Safra')?.value);
            form.get('numero_campo').setValue(formCard.get('Nr_campo')?.value);
            form.get('umidade').setValue(formCard.get('Umidade')?.value);
        }

        return await form;
    }

    private async buildFormII(form: FormGroup, formCard: FormGroup): Promise<FormGroup> {

        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('peso_amostra').setValue(formCard.get('peso_amostra')?.value);
            form.get('peso_liquido').setValue(formCard.get('peso_liquido')?.value);
            form.get('palha').setValue(formCard.get('palha')?.value);
            form.get('impurezas').setValue(formCard.get('impurezas')?.value);
            form.get('peso_sementes').setValue(formCard.get('peso_sementes')?.value);
            form.get('peso_material').setValue(formCard.get('peso_material')?.value);
            form.get('sabugo_milho').setValue(formCard.get('sabugo_milho')?.value);
            form.get('espigas_atipicas').setValue(formCard.get('espigas_atipicas')?.value);
            form.get('descarte_mesa').setValue(formCard.get('descarte_mesa')?.value);
            form.get('observacao_amostra').setValue(formCard.get('observacao_amostra')?.value);
        }
        else {
            form.get('graos_ardidos').setValue(formCard.get('Graos_Ardidos')?.value);
            // form.get('esclerocitos').setValue(formCard.get('Esclerocitos')?.value);
            form.get('sabugo_milho').setValue(formCard.get('Sabugo')?.value);
            form.get('graos_carunchados').setValue(formCard.get('Graos_Carunchados')?.value);
            form.get('sementes_quebradas').setValue(formCard.get('Sementes_Quebradas')?.value);
            form.get('outros_cultivares').setValue(formCard.get('Out_Cultivares')?.value);
            // form.get('umidade_direcionamento').setValue(formCard.get('Umidade_Direcionamento')?.value);
            // form.get('umidade').setValue(formCard.get('Umidade')?.value);
            form.get('observacao').setValue(formCard.get('Observacao')?.value);
        }

        return await form;
    }

    private async buildFormIII(form: FormGroup, formCard: FormGroup): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('palha_impureza_cerar').setValue(formCard.get('palha_impureza_cerar')?.value);
            form.get('sabugo_cerar').setValue(formCard.get('sabugo_cerar')?.value);
            form.get('semente_cerar').setValue(formCard.get('semente_cerar')?.value);
            form.get('palha_amostra').setValue(formCard.get('palha_amostra')?.value);
            form.get('peso_liquido_carga_umidade').setValue(formCard.get('peso_liquido_carga_umidade')?.value);
            form.get('palha_na_carga').setValue(formCard.get('palha_na_carga')?.value);
            form.get('previsao_mpl_kg').setValue(formCard.get('previsao_mpl_kg')?.value);
            form.get('previsao_mpl_porcento').setValue(formCard.get('previsao_mpl_porcento')?.value);
            form.get('previsao_ds_graos_kg').setValue(formCard.get('previsao_ds_graos_kg')?.value);
            form.get('previsao_ds_graos_porcento').setValue(formCard.get('previsao_ds_graos_porcento')?.value);
            form.get('perda_processo').setValue(formCard.get('perda_processo')?.value);
        }
        else {
            form.get('palha_imp_esp').setValue(formCard.get('Palha_Impurezas_Outras')?.value);
            form.get('desconto_palha').setValue(formCard.get('Desc_Palh_Imp_Ardi_Escler')?.value);
            form.get('quantidade_palha').setValue(formCard.get('Qtde_Palh_Imp_Ardi_Escl')?.value);
            form.get('quantidade_palha_milho').setValue(formCard.get('Qtde_Palha')?.value);
            form.get('quantidade_sabugo').setValue(formCard.get('Qtde_Sabugo')?.value);
            form.get('desconto_palha_imp').setValue(formCard.get('Desc_Palh_Imp')?.value);
            form.get('peso_graos_amostra').setValue(formCard.get('Peso_Graos_Amostra')?.value);
            form.get('quantidade_impurezas').setValue(formCard.get('Qtde_Impurezas')?.value);
            form.get('sementes').setValue(formCard.get('Sementes')?.value);
            form.get('sub_total_descarte').setValue(formCard.get('Sub_Total_Desc_Grao_g')?.value);
            form.get('sub_total_descart_prc').setValue(formCard.get('Sub_Total_Desc_Grao_porc')?.value);
            form.get('umidade_deducao').setValue(formCard.get('Umidade_Deduzir')?.value);
            form.get('desconto_impureza_palha').setValue(formCard.get('Desc_Impu_Palh')?.value);
            form.get('desconto_sabugo').setValue(formCard.get('Desc_Sabugo')?.value);
            form.get('total_desconto').setValue(formCard.get('Total_Desc_Pal_Imp_Sabugo')?.value);
            form.get('peso_liquido_umido').setValue(formCard.get('Peso_Liquido_Umido')?.value);
            form.get('desconto_umidade').setValue(formCard.get('Desconto_Umidade')?.value);
            form.get('peso_liquido_seco').setValue(formCard.get('Peso_Liquido_Seco')?.value);
            form.get('rendimento_rw_mpl').setValue(formCard.get('Rendimento_Rw')?.value);
            form.get('validacao').setValue(formCard.get('validacao')?.value);
            form.get('resp_validacao').setValue(formCard.get('resp_validacao')?.value);
            form.get('created_by').setValue(formCard.get('criado_por')?.value);
        }

        return await form;
    }

    private async buildFormV(form: FormGroup, formCard: FormGroup): Promise<FormGroup> {
        if (this.areaSelect.includes('Pré-Básica')) {
            form.get('created_by').setValue(formCard.get('criado_por').value);
            form.get('observacao').setValue(formCard.get('observacao').value);
            form.get('origem_negocio').setValue('3');
        }

        return await form;
    }


    private async buildFormVI(form: FormGroup, formCard: FormGroup): Promise<FormGroup> {
        form.get('qnt_espiga_caixa').setValue(formCard.get('qnt_espiga_caixa')?.value);
        form.get('espiga_atipica').setValue(formCard.get('espiga_atipica')?.value);
        form.get('prc_espiga_atipica').setValue(formCard.get('prc_espiga_atipica')?.value);
        form.get('morte_prematura').setValue(formCard.get('morte_prematura')?.value);
        form.get('prc_morte_prematura').setValue(formCard.get('prc_morte_prematura')?.value);
        return await form;
    }



    public async updateForm(form: FormGroup, arrForm: Array<FormGroup>, generalService: GeneralService): Promise<void> {
        await Promise.all([this.updateFormI(form, arrForm[0], generalService), this.updateFormII(form, arrForm[1], generalService), this.updateFormIII(form, arrForm[2], generalService), this.updateFormVI(form, arrForm[3], generalService), this.updateFormV(form, arrForm[4], generalService)]);
    }

    private async updateFormI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('cerar_basica').setValue(data.formulario.cerar_basica);
            formCard.get('lote_rw').setValue(data.formulario.lote_rw);
            formCard.get('cooperante').setValue(data.formulario.cooperante);
            formCard.get('gleba').setValue(data.formulario.gleba);
            formCard.get('contrato_juridico').setValue(data.formulario.contrato_juridico);
            formCard.get('geracao').setValue(data.formulario.geracao);
            formCard.get('site_origem').setValue(data.formulario.site_origem);
            formCard.get('site_recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('safra').setValue(data.formulario.safra);
            formCard.get('safra_basica').setValue(data.formulario.safra_basica);
            formCard.get('numero_campo').setValue(data.formulario.numero_campo);
            formCard.get('especie').setValue(data.formulario.especie);
            formCard.get('hibrido_rnc').setValue(data.formulario.hibrido_rnc);
            formCard.get('tipo_colheita').setValue(data.formulario.tipo_colheita);
            formCard.get('amostra_seca_molhada').setValue(data.formulario.amostra_seca_molhada);
            formCard.get('peso_total_rw').setValue(data.formulario.peso_total_rw);
            formCard.get('umidade').setValue(data.formulario.umidade);
        }
        else {
            formCard.get('Cerar').setValue(data.formulario.cerar);
            formCard.get('Lote_rw').setValue(data.formulario.lote_rw);
            formCard.get('Site_Origem').setValue(data.formulario.site_origem);
            formCard.get('Site_Recebimento').setValue(data.formulario.site_recebimento);
            formCard.get('Cooperante').setValue(data.formulario.cooperante);
            formCard.get('Gleba').setValue(data.formulario.gleba);
            formCard.get('Contrato_Juridico').setValue(data.formulario.contrato_juridico);
            formCard.get('Produto').setValue(data.formulario.produto);
            formCard.get('Peso_Amostra').setValue(data.formulario.peso_amostra);
            formCard.get('Peso_Liquido').setValue(data.formulario.peso_liquido);
            formCard.get('Palha').setValue(data.formulario.palha);
            formCard.get('Outras_Sementes').setValue(data.formulario.outras_sementes);
            formCard.get('Impurezas').setValue(data.formulario.impurezas);
            formCard.get('Safra').setValue(data.formulario.safra);
            formCard.get('Nr_campo').setValue(data.formulario.numero_campo);
            formCard.get('Umidade').setValue(data.formulario.umidade);
        }

    }

    private async updateFormII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('peso_amostra').setValue(data.formulario.peso_amostra);
            formCard.get('peso_liquido').setValue(data.formulario.peso_liquido);
            formCard.get('palha').setValue(data.formulario.palha);
            formCard.get('impurezas').setValue(data.formulario.impurezas);
            formCard.get('peso_sementes').setValue(data.formulario.peso_sementes);
            formCard.get('peso_material').setValue(data.formulario.peso_material);
            formCard.get('sabugo_milho').setValue(data.formulario.sabugo_milho);
            formCard.get('espigas_atipicas').setValue(data.formulario.espigas_atipicas);
            formCard.get('descarte_mesa').setValue(data.formulario.descarte_mesa);
            formCard.get('observacao_amostra').setValue(data.formulario.observacao_amostra);
        }
        else {
            formCard.get('Graos_Ardidos').setValue(data.formulario.graos_ardidos);
            // formCard.get('Esclerocitos').setValue(data.formulario.esclerocitos);
            formCard.get('Sabugo').setValue(data.formulario.sabugo_milho);
            formCard.get('Graos_Carunchados').setValue(data.formulario.graos_carunchados);
            formCard.get('Sementes_Quebradas').setValue(data.formulario.sementes_quebradas);
            formCard.get('Out_Cultivares').setValue(data.formulario.outros_cultivares);
            // formCard.get('Umidade_Direcionamento').setValue(data.formulario.umidade_direcionamento);
            // formCard.get('Umidade').setValue(data.formulario.umidade);
            formCard.get('Observacao').setValue(data.formulario.observacao);
        }

    }

    private async updateFormIII(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('palha_impureza_cerar').setValue(data.formulario.palha_impureza_cerar);
            formCard.get('sabugo_cerar').setValue(data.formulario.sabugo_cerar);
            formCard.get('semente_cerar').setValue(data.formulario.semente_cerar);
            formCard.get('palha_amostra').setValue(data.formulario.palha_amostra);
            formCard.get('peso_liquido_carga_umidade').setValue(data.formulario.peso_liquido_carga_umidade);
            formCard.get('palha_na_carga').setValue(data.formulario.palha_na_carga);
            formCard.get('previsao_mpl_kg').setValue(data.formulario.previsao_mpl_kg);
            formCard.get('previsao_mpl_porcento').setValue(data.formulario.previsao_mpl_porcento);
            formCard.get('previsao_ds_graos_kg').setValue(data.formulario.previsao_ds_graos_kg);
            formCard.get('previsao_ds_graos_porcento').setValue(data.formulario.previsao_ds_graos_porcento);
            formCard.get('perda_processo').setValue(data.formulario.perda_processo);
        }
        else {
            formCard.get('Palha_Impurezas_Outras').setValue(data.formulario.palha_imp_esp);
            formCard.get('Desc_Palh_Imp_Ardi_Escler').setValue(data.formulario.desconto_palha);
            formCard.get('Qtde_Palh_Imp_Ardi_Escl').setValue(data.formulario.quantidade_palha);
            formCard.get('Qtde_Palha').setValue(data.formulario.quantidade_palha_milho);
            formCard.get('Qtde_Sabugo').setValue(data.formulario.quantidade_sabugo);
            formCard.get('Desc_Palh_Imp').setValue(data.formulario.desconto_palha_imp);
            formCard.get('Peso_Graos_Amostra').setValue(data.formulario.peso_graos_amostra);
            formCard.get('Qtde_Impurezas').setValue(data.formulario.quantidade_impurezas);
            formCard.get('Sementes').setValue(data.formulario.sementes);
            formCard.get('Sub_Total_Desc_Grao_g').setValue(data.formulario.sub_total_descarte);
            formCard.get('Sub_Total_Desc_Grao_porc').setValue(data.formulario.sub_total_descart_prc);
            formCard.get('Umidade_Deduzir').setValue(data.formulario.umidade_deducao);
            formCard.get('Desc_Impu_Palh').setValue(data.formulario.desconto_impureza_palha);
            formCard.get('Desc_Sabugo').setValue(data.formulario.desconto_sabugo);
            formCard.get('Total_Desc_Pal_Imp_Sabugo').setValue(data.formulario.total_desconto);
            formCard.get('Peso_Liquido_Umido').setValue(data.formulario.peso_liquido_umido);
            formCard.get('Desconto_Umidade').setValue(data.formulario.desconto_umidade);
            formCard.get('Peso_Liquido_Seco').setValue(data.formulario.peso_liquido_seco);
            formCard.get('Rendimento_Rw').setValue(data.formulario.rendimento_rw_mpl);
            formCard.get('validacao').setValue(data.formulario.validacao);
            formCard.get('resp_validacao').setValue(data.formulario.resp_validacao);
            formCard.get('criado_por').setValue(data.formulario.created_by);
        }
    }

    private async updateFormVI(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        formCard.get('qnt_espiga_caixa').setValue(data.formulario.qnt_espiga_caixa);
        formCard.get('espiga_atipica').setValue(data.formulario.espiga_atipica);
        formCard.get('prc_espiga_atipica').setValue(data.formulario.prc_espiga_atipica);
        formCard.get('morte_prematura').setValue(data.formulario.morte_prematura);
        formCard.get('prc_morte_prematura').setValue(data.formulario.prc_morte_prematura);
    }
    private async updateFormV(data: any, formCard: FormGroup, generalService: GeneralService): Promise<void> {
        if (this.areaSelect.includes('Pré-Básica')) {
            formCard.get('criado_por').setValue(data.formulario.created_by);
            formCard.get('observacao').setValue(data.formulario.observacao);

        }
    }

}
